import { useTranslation } from 'react-i18next';
import { FinecoAgentIcon } from 'shared/assets/svg/FinecoAgentIcon';
import colorsStore from 'shared/store/colorsStore';
import { MessageData } from './ChatInput';
import { SuggestedPrompts } from './SuggestedPrompts';

type AssistantWelcomeProps = {
  sendUserMessage: (data: MessageData) => void;
  isDisabled?: boolean;
  isConnectionOpen: boolean;
};

export const ChatWelcome: React.FC<AssistantWelcomeProps> = ({ sendUserMessage, isConnectionOpen }) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  const { t } = useTranslation();
  const iconSizeClass = `icon-size-32-32`;
  return (
    <>
      <div className="flex-grow">
        <div className="grid h-full place-items-center">
          <div className="text-center">
            <div className="animated-div mb-4 flex items-center justify-center gap-4">
              <FinecoAgentIcon className={iconSizeClass} />
              <h1
                style={{
                  color: colorsConfig.chatCopyColor,
                  fontSize: 24,
                  marginTop: 5,
                }}
              >
                {isConnectionOpen ? t('assistant.howCanIHelp') : t('assistant.connecting')}
              </h1>
            </div>
            {isConnectionOpen && (
              <SuggestedPrompts onSend={(text) => sendUserMessage({ text: text, file: undefined })} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
